export default __webpack_public_path__ + "static/media/F0005.aecb3e70.png";